import { type ChatStatus } from 'ai';

import { type SidekickActivity } from 'utils/sidekick';

import { type MimUIMessage } from './sdk/structuredResponse';

type ChatState = {
  status: ChatStatus;
  messages: readonly MimUIMessage[];
  isMinimized: boolean;
  hasPendingPrompt: boolean;
};

/** What the Sidekick is doing, from the state of its chat. */
export const toSidekickActivity = ({
  status,
  messages,
  isMinimized,
  hasPendingPrompt,
}: ChatState): SidekickActivity => {
  if (hasPendingPrompt || status === 'submitted' || status === 'streaming') {
    return 'working';
  }
  if (status === 'error') return 'error';
  if (isMinimized) return 'closed';

  const last = messages.at(-1);
  const hasChoices =
    last?.role === 'assistant' &&
    last.parts.some((part) => part.type === 'data-choices');

  return hasChoices ? 'asking' : 'idle';
};
